function escapeHtml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/**
 * Confirmation for "make this version current". Promoting swaps what every
 * pasted snippet serves (the CDN `current/` mirror), including rolling BACK
 * to an older version, so it deserves an explicit confirm — but unlike
 * deletes it is fully reversible by promoting something else.
 */
export function openPromoteVersionModal(input: {
  componentName: string;
  version: number;
  currentVersion: number | null;
}): Promise<boolean> {
  return new Promise((resolve) => {
    const dialog = document.createElement('sl-dialog');
    dialog.label = `Make v${input.version} current`;
    const fromNote =
      input.currentVersion == null
        ? 'Nothing is currently live for this component.'
        : `Currently live: <code>v${input.currentVersion}</code>.`;
    const rollbackNote =
      input.currentVersion != null && input.version < input.currentVersion
        ? '<br><strong>This is a rollback</strong> to an older version.'
        : '';
    dialog.innerHTML = `
      <div class="field-stack">
        <sl-alert variant="primary" open>
          <sl-icon slot="icon" name="arrow-up-circle"></sl-icon>
          Version <code>v${input.version}</code> of
          <code>${escapeHtml(input.componentName)}</code> will become what all
          pasted snippets serve. ${fromNote}${rollbackNote}
        </sl-alert>
      </div>

      <sl-button slot="footer" id="pv-cancel" variant="default">Cancel</sl-button>
      <sl-button slot="footer" id="pv-promote" variant="primary">Make current</sl-button>
    `;

    document.body.appendChild(dialog);

    const cancelBtn = dialog.querySelector<HTMLElement>('#pv-cancel')!;
    const promoteBtn = dialog.querySelector<HTMLElement>('#pv-promote')!;
    let confirmed = false;

    cancelBtn.addEventListener('click', () => dialog.hide());
    promoteBtn.addEventListener('click', () => {
      confirmed = true;
      dialog.hide();
    });
    dialog.addEventListener('sl-after-hide', () => {
      dialog.remove();
      resolve(confirmed);
    });

    requestAnimationFrame(() => {
      (dialog as HTMLElement & { show: () => void }).show();
    });
  });
}
